import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { EXCLUDED_OPERATING_CARRIER } from '../../../const/Company';

import './FlightCompanyLogo.css';

const propTypes = {
  id: PropTypes.string.isRequired,
  flightGroup: PropTypes.arrayOf(PropTypes.object),
  className: PropTypes.string
};

const AZUL_COMPANY_CODE = 'AD';

class FlightCompanyLogo extends React.Component {
  constructor(props) {
    super(props);
    this.marketingCarrierCode = this.getCompanyCarrierCode(props);
  }

  getCompanyCarrierCode(props) {
    const flightGroup = props.flightGroup
      .filter(
        e =>
          e.marketingCarrier !== AZUL_COMPANY_CODE &&
          e.operatingCarrier !== EXCLUDED_OPERATING_CARRIER
      )
      .pop();

    return flightGroup != null ? flightGroup.marketingCarrier : null;
  }

  render() {
    return (
      <div
        id={`componentFlightCompanyLogo-${this.props.id}`}
        className={`componentFlightCompanyLogo ${this.props.className || ''}`}>
        <Row>
          <Col xs={12} sm={12}>
            <div className={`icon-${this.marketingCarrierCode || AZUL_COMPANY_CODE}`} />
          </Col>
        </Row>
      </div>
    );
  }
}

FlightCompanyLogo.propTypes = propTypes;

export default FlightCompanyLogo;



// WEBPACK FOOTER //
// ./src/components/flightSelection/flightCompanyLogo/FlightCompanyLogo.jsx